/*
 * @Description: 
 * @Author: kecraft
 * @Date: 2024-08-19 09:22:39
 * @LastEditors: kecraft
 * @LastEditTime: 2024-08-19 16:31:00
 * @FilePath: /custom-website-desk/src/api/modules/webset.js
 */
import http from "../http";

export default {
  // 火蓝机电PDF获取
  getCulturePDF(param) {
    return http.get("/api/corporateCulture/getCulturePDF", param);
  },

  // 获取集团概览banner
  getPageConfigDetail(param) {
    return http.get(`/api/pageConfig/getPageConfigDetail/${param}`, param);
  },

  // 获取成员单位
  getMemberList(param) {
    return http.get(`/api/memberUnit/list`, param);
  },

  // 获取数字信息
  getNumberListInfo(param) {
    return http.get(`/api/listInfo/list`, param);
  },

  // 获取管理团队
  getManageTeamList(param) {
    return http.get(`/api/manageTeam/list`, param);
  },

  // 获取集团荣耀
  getHonorList(param) {
    return http.get(`/api/honor/list`, param);
  },

  // 获取发展历程
  getDevelopmentHistory(param) {
    return http.get(`/api/developmentHistory/list`, param);
  },

  // 获取大事记表
  getDownloadList(param) {
    return http.get(`/api/download/list`, param);
  },

  // 领导关怀 党群之窗获取子栏目信息
  getArticlePage(param) {
    return http.get(`/api/article/page`, param);
  },

  // 党群之窗获取子栏目
  getSubColumnsList(param) {
    return http.get(`/api/corporateCulture/getSubColumnsList`, param);
  },

  // 获取视频刊物分类列表
  getPublicationClassification(param) {
    return http.get(
      `/api/corporateCulture/getPublicationClassification`,
      param
    );
  },
  // 获取图片
  getHLJDImageList(param) {
    return http.get(`/api/file/getHLJDImageList`, param);
  },

  // 附件上传/feedback/create
  fileuploadFile(param, callback) {
    return http.upLoadFile2("/api/file/uploadFile", param, callback);
  },

  // 新增举报
  feedbackCreate(param) {
    return http.post("/api/feedback/create", param);
  },

  // 根据id获取文章
  getById(param) {
    return http.get(`/api/article/getById`, param);
  },

  // 获取友情链接
  getFriendshipLink(param) {
    return http.get(`/api/friendshipLink/list`, param);
  },

  // 获取产品展示
  getPageConfigList(param) {
    return http.get(`/api/pageConfig/getPageConfigList/${param}`);
  },
  /**
 * 企业文化 - 火蓝机电 - 列表
 * @param {*} param 
 * @returns 
 */
  qywhListInfo(param) {
    return http.get(`/api/listInfo/list`, param)
  }
};
